import i18next from "i18next"
import React, { MouseEvent } from "react"
import { useTranslation } from "react-i18next"

import { ButtonLink } from "~/components/Button/Button"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import imgMdMin from "./assets/img-md-min.jpg"
import imgSmOnly from "./assets/img-sm-only.jpg"
import styles from "./index.module.css"

export const Model: React.FC = () => {
  const { t } = useTranslation()
  const currentLang = i18next.language

  const ITEMS = [
    [
      {
        title: t("responsible-investment-principles.Model.List.Item.01.Title.01"),
        description: t("responsible-investment-principles.Model.List.Item.01.Description.01"),
      },
      {
        title: t("responsible-investment-principles.Model.List.Item.01.Title.02"),
        description: t("responsible-investment-principles.Model.List.Item.01.Description.02"),
      },
    ],
    [
      {
        title: t("responsible-investment-principles.Model.List.Item.02.Title.01"),
        description: t("responsible-investment-principles.Model.List.Item.02.Description.01"),
      },
      {
        title: t("responsible-investment-principles.Model.List.Item.02.Title.02"),
        description: t("responsible-investment-principles.Model.List.Item.02.Description.02"),
      },
      {
        title: t("responsible-investment-principles.Model.List.Item.02.Title.03"),
        description: t("responsible-investment-principles.Model.List.Item.02.Description.03"),
      },
    ],
    [
      {
        title: t("responsible-investment-principles.Model.List.Item.03.Title.01"),
        description: "",
      },
      {
        title: t("responsible-investment-principles.Model.List.Item.03.Title.02"),
        description: "",
      },
    ],
  ]

  const HEADS = [
    t("responsible-investment-principles.Model.List.Item.01.Head"),
    t("responsible-investment-principles.Model.List.Item.02.Head"),
    t("responsible-investment-principles.Model.List.Item.03.Head"),
  ]

  const handlerClick = (e: MouseEvent): void => {
    const description = (e.currentTarget as HTMLElement).nextSibling as HTMLElement
    const descriptionSelfHeight = description.scrollHeight.toString()
    const isOpen = description.dataset.state === "open"

    if (!isOpen) {
      description.style.height = `${descriptionSelfHeight}px`
      description.dataset.state = "open"
    }

    if (isOpen) {
      description.removeAttribute("style")
      description.removeAttribute("data-state")
    }
  }

  return (
    <div className={styles.Wrapper}>
      <div className="container">
        <div className={styles.Head}>
          <Heading as="h2" className={styles.Heading} like="h2">
            <Raw html={t("responsible-investment-principles.Model.Title")} />
          </Heading>

          <ButtonLink
            className={styles.Download}
            href={
              currentLang === "ru"
                ? "/upload/responsible-investment-principles-scheme-rus.pdf"
                : "/upload/responsible-investment-principles-scheme-eng.pdf"
            }
            rel="noopener noreferrer"
            target="_blank"
            view="rounded"
          >
            <Raw html={t("responsible-investment-principles.Model.ButtonLink")} />
          </ButtonLink>
        </div>

        <div className={styles.Inner}>
          <div className={styles.Image}>
            <picture>
              <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={imgSmOnly} />
              <source media="(min-width: 1024px)" srcSet={imgMdMin} />
              <img src={imgMdMin} />
            </picture>
          </div>

          <div className={styles.List}>
            {ITEMS.map((lines, i) => (
              <div key={i}>
                <Heading like="h3">
                  <Raw html={t(HEADS[i])} />
                </Heading>

                {lines.map((line, j) => (
                  <div key={j} className={styles.Item}>
                    <Heading
                      as="span"
                      className={line.description && styles.Title}
                      like="h4"
                      onClick={line.description ? handlerClick : undefined}
                    >
                      <Raw html={line.title} />
                    </Heading>

                    <ul
                      className={styles.Description}
                      dangerouslySetInnerHTML={{ __html: line.description }}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
